import { TranslateModule } from './../../translate/translate.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfilePreviewComponent } from './profile-preview/profile-preview.component';
import { AvatarModule } from '../avatar/public-api';
import { ButtonModule } from '@lib/ui';
import { PatientStatusBadgeModule } from '../../components/patient-status-badge/patient-status-badge.module';

@NgModule({
  declarations: [ProfilePreviewComponent],
  exports: [ProfilePreviewComponent],
  imports: [CommonModule, AvatarModule, AvatarModule, ButtonModule, TranslateModule, PatientStatusBadgeModule],
})
export class ProfilePreviewModule {}
